<template>
  <div id="app">
    <NavbarSect :currentLang="currentLang" @switch-language="switchLanguage" />
    <HomePage :currentLang="currentLang" />
  </div>
</template>

<script>
import NavbarSect from './components/NavbarSect.vue'
import HomePage from './pages/HomePage.vue'

export default {
  name: 'App',
  components: {
    NavbarSect,
    HomePage
  },
  data() {
    return {
      currentLang: 'en'
    }
  },
  methods: {
    switchLanguage(lang) {
      this.currentLang = lang
      this.$i18n.locale = lang
      document.documentElement.lang = lang
    }
  },
  mounted() {
    document.documentElement.lang = this.currentLang
  }
}
</script>

<style>
@import 'https://www.w3schools.com/w3css/4/w3.css';
@import 'https://fonts.googleapis.com/css?family=Raleway';
@import 'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css';

body,
h1,
h2,
h3,
h4,
h5,
h6 {
  font-family: "Raleway", sans-serif
}

h3 {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent
}

h5 {
  /* font-weight: ;   */
  /* background: linear-gradient(135deg, #ca4672 0%, #a2764b 100%); */
  /* -webkit-background-clip: text; */
  /* -webkit-text-fill-color: transparent */
}

body,
html {
  height: 100%;
  line-height: 1.8;
}

.bgimg-1 {
  background-position-x: left;
  background-position-y: top;
  background-attachment: fixed;
  background-size: cover;
  /* background-image: url("./assets/red.png");   */
  background-image: url("./assets/react_scal_2.jpg");  
  /* background-image: url("./assets/npm.jpg");   */
  /* background-image: url("./assets/rback.jpg");   */
  min-height: 100%;
}

.bgimg-btm {
  background-position-x: left;
  background-position-y: center;
  background-size: cover;
  /* background-image: url("./assets/red.png");   */
  background-image: url("./assets/botm.jpg");  
  /* background-image: url("./assets/npm.jpg");   */
  /* background-image: url("./assets/rback.jpg");   */
  min-height: 100%;
}

.bg-wh {
  background-position: center;
  background-size: cover;
  background-image: url("./assets/cntc.png");
  /* background-image: url("./assets/wh2gr.png"); */
  min-height: 100%;
}

.bg-wh2gr {
  background-position: center;
  background-size: cover;
  background-image: url("./assets/wh2gr.png");
  /* background-image: url("./assets/wh2gr.png"); */
  min-height: 100%;
}

.bg-gr2wh {
  background-position: center;
  background-size: cover;
  background-image: url("./assets/gr2wh.png");
  /* background-image: url("./assets/wh2gr.png"); */
  min-height: 100%;
}

.w3-bar .w3-button {
  padding: 16px;
}

.fa {
  margin: 2px;
}

.lang-switcher {
  margin-left: 16px;
  cursor: pointer;
}

.lang-text {
  vertical-align: middle;
}

.redsh {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.bluesh {
  background: linear-gradient(135deg, #ee667a 0%, #a2764b 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

._browser3dwrapper_1cl88_202 {
  position: absolute;
  /* top: -34px; */
  /* left: 30%; */
  right: 0%;
  perspective: 750px;
  z-index: -1
}

._useCaseCycle_1cl88_1 {
  /* position: relative; */
  /* width: 100%; */
  padding-left: 40%;
  /* height: 50%; */
  /* z-index: -1 */
}

._useCaseCycle__editor_1cl88_209 {
  display: flex;
  flex-direction: column;
  width: 700px;
  /* width: 880px; */
  height: 600px;
  border-radius: 6px;
  box-shadow: 0 0 0 1px #ffffff1a;
  z-index: -1;
  transform: rotateY(-18deg)
}

._useCaseCycle__editor__browser_1cl88_235 {
  position: relative;
  width: 100%;
  height: 40px;
  box-shadow: 0 1px #ffffff1a
}

._useCaseCycle__editor__browser__tab_1cl88_242 {
  position: absolute;
  bottom: -1px;
  left: 140px;
  width: 270px;
  height: calc(100% - 4px);
  border: solid 1px rgba(247, 243, 243, 0.1);
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
  border-bottom: none;
  background-color: var(--public-bg-dark-accent-hex);
  background-image: url("data:image/svg+xml,%3csvg%20width='46'%20height='11'%20viewBox='0%200%2046%2011'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20opacity='0.24'%3e%3crect%20x='17'%20y='6'%20width='29'%20height='1'%20rx='0.5'%20fill='%23555F6A'/%3e%3c/g%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: 16px 8px;
  background-size: 92px
}

._useCaseCycle__editor__address_1cl88_259 {
  width: 100%;
  height: 40px
}

._useCaseCycle__editor__editor_1cl88_264 {
  display: flex;
  flex-direction: column;
  flex: 1;
  width: 100%;
  box-shadow: 0 -1px #ffffff1a
}

._useCaseCycle__editor__editor_1cl88_264 ._mockEditor_1cl88_271 {
  flex: 1;
  display: flex;
  width: 100%
}

._useCaseCycle__editor__editor_1cl88_264 ._mockEditor_1cl88_271 ._mockEditor__left_bar_1cl88_276 {
  width: 40px;
  height: 100%
}

._mockEditor__file_explorer_1cl88_281 {
  width: 200px;
  height: 100%;
  border-right: solid 1px rgba(255, 255, 255, .1);
  border-top: none;
  border-bottom: none;
  background-color: #00000014;
  transition: width 1.2s ease;
  background-image: url("data:image/svg+xml,%3csvg%20width='61'%20height='222'%20viewBox='0%200%2061%20222'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20opacity='0.2'%3e%3crect%20width='32'%20height='2'%20rx='1'%20fill='%23616974'/%3e%3crect%20x='13'%20y='10'%20width='14'%20height='2'%20rx='1'%20fill='%23616974'/%3e%3crect%20x='13'%20y='70'%20width='14'%20height='2'%20rx='1'%20fill='%23616974'/%3e%3crect%20width='14'%20height='2'%20rx='1'%20transform='matrix(1%200%200%20-1%2013%20152)'%20fill='%23616974'/%3e%3crect%20x='13'%20y='110'%20width='14'%20height='2'%20rx='1'%20fill='%23616974'/%3e%3crect%20x='13'%20y='210'%20width='14'%20height='2'%20rx='1'%20fill='%23616974'/%3e%3crect%20x='13'%20y='20'%20width='28'%20height='2'%20rx='1'%20fill='%23616974'/%3e%3crect%20width='28'%20height='2'%20rx='1'%20transform='matrix(1%200%200%20-1%2013%20142)'%20fill='%23616974'/%3e%3crect%20x='13'%20y='100'%20width='28'%20height='2'%20rx='1'%20fill='%23616974'/%3e%3crect%20x='13'%20y='30'%20width='22'%20height='2'%20rx='1'%20fill='%23616974'/%3e%3crect%20x='26'%20y='200'%20width='22'%20height='2'%20rx='1'%20fill='%23616974'/%3e%3crect%20x='13'%20y='80'%20width='22'%20height='2'%20rx='1'%20fill='%23616974'/%3e%3crect%20x='13'%20y='160'%20width='22'%20height='2'%20rx='1'%20fill='%23616974'/%3e%3crect%20x='13'%20y='170'%20width='22'%20height='2'%20rx='1'%20fill='%23616974'/%3e%3crect%20x='13'%20y='180'%20width='17'%20height='2'%20rx='1'%20fill='%23616974'/%3e%3crect%20x='13'%20y='120'%20width='22'%20height='2'%20rx='1'%20fill='%23616974'/%3e%3crect%20x='13'%20y='220'%20width='22'%20height='2'%20rx='1'%20fill='%23616974'/%3e%3crect%20x='26'%20y='40'%20width='22'%20height='2'%20rx='1'%20fill='%23616974'/%3e%3crect%20x='26'%20y='60'%20width='35'%20height='2'%20rx='1'%20fill='%23616974'/%3e%3crect%20x='26'%20y='50'%20width='17'%20height='2'%20rx='1'%20fill='%23616974'/%3e%3crect%20x='26'%20y='190'%20width='17'%20height='2'%20rx='1'%20fill='%23616974'/%3e%3crect%20y='90'%20width='19'%20height='2'%20rx='1'%20fill='%23616974'/%3e%3crect%20y='130'%20width='26'%20height='2'%20rx='1'%20fill='%23616974'/%3e%3c/g%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: 42px 32px;
  background-size: 100px
}

._mockEditor__code_1cl88_295 {
  position: relative;
  flex: 1.1;
  height: 100%;
  border-right: solid 1px rgba(255, 255, 255, .1);
  background-color: #00000014;
  transition: flex 1.2s ease, height 1.2s ease;
  background-image: url("data:image/svg+xml,%3csvg%20width='120'%20height='52'%20viewBox='0%200%20120%2052'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20opacity='0.24'%3e%3crect%20width='21'%20height='2'%20rx='1'%20fill='%233D9CB1'/%3e%3crect%20x='25'%20width='27'%20height='2'%20rx='1'%20fill='%2392A1B2'%20fill-opacity='0.52'/%3e%3crect%20x='19'%20y='30'%20width='26'%20height='2'%20rx='1'%20fill='%233D9CB1'/%3e%3crect%20x='19'%20y='40'%20width='18'%20height='2'%20rx='1'%20fill='%233D9CB1'/%3e%3crect%20x='56'%20width='37'%20height='2'%20rx='1'%20fill='%23B6A54B'/%3e%3crect%20x='49'%20y='30'%20width='52'%20height='2'%20rx='1'%20fill='%2392A1B2'%20fill-opacity='0.52'/%3e%3crect%20x='41'%20y='40'%20width='34'%20height='2'%20rx='1'%20fill='%2392A1B2'%20fill-opacity='0.52'/%3e%3crect%20y='50'%20width='22'%20height='2'%20rx='1'%20fill='%2392A1B2'%20fill-opacity='0.52'/%3e%3crect%20x='79'%20y='40'%20width='33'%20height='2'%20rx='1'%20fill='%23B6A54B'/%3e%3crect%20y='20'%20width='33'%20height='2'%20rx='1'%20fill='%233D9CB1'/%3e%3crect%20x='37'%20y='20'%20width='83'%20height='2'%20rx='1'%20fill='%2392A1B2'%20fill-opacity='0.52'/%3e%3c/g%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: 52px 52px;
  background-size: 200px
}

._mockEditor__codeTerminal_1cl88_308 {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 32%;
  border-top: solid 1px rgba(255, 255, 255, .1);
  background-color: #00000014;
  transition: height 1.2s ease;
  background-image: url("data:image/svg+xml,%3csvg%20width='87'%20height='122'%20viewBox='0%200%2087%20122'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20opacity='0.2'%3e%3crect%20width='21'%20height='2'%20rx='1'%20fill='%23555F6A'/%3e%3crect%20y='60'%20width='24'%20height='2'%20rx='1'%20fill='%2392A1B2'%20fill-opacity='0.52'/%3e%3crect%20x='42'%20y='72'%20width='24'%20height='2'%20rx='1'%20transform='rotate(-180%2042%2072)'%20fill='%2392A1B2'%20fill-opacity='0.52'/%3e%3crect%20x='28'%20y='60'%20width='14'%20height='2'%20rx='1'%20fill='%2392A1B2'%20fill-opacity='0.52'/%3e%3crect%20x='14'%20y='72'%20width='14'%20height='2'%20rx='1'%20transform='rotate(-180%2014%2072)'%20fill='%2392A1B2'%20fill-opacity='0.52'/%3e%3crect%20x='46'%20y='60'%20width='33'%20height='2'%20rx='1'%20fill='%2392A1B2'%20fill-opacity='0.52'/%3e%3crect%20y='20'%20width='12'%20height='2'%20rx='1'%20fill='%23555F6A'/%3e%3crect%20y='80'%20width='12'%20height='2'%20rx='1'%20fill='%23555F6A'/%3e%3crect%20y='30'%20width='12'%20height='2'%20rx='1'%20fill='%23555F6A'/%3e%3crect%20y='40'%20width='12'%20height='2'%20rx='1'%20fill='%23555F6A'/%3e%3crect%20y='110'%20width='12'%20height='2'%20rx='1'%20fill='%23555F6A'/%3e%3crect%20x='16'%20y='20'%20width='22'%20height='2'%20rx='1'%20fill='%233A8E51'/%3e%3crect%20x='42'%20y='20'%20width='27'%20height='2'%20rx='1'%20fill='%233A8E51'/%3e%3crect%20y='50'%20width='12'%20height='2'%20rx='1'%20fill='%23555F6A'/%3e%3crect%20x='42'%20y='50'%20width='17'%20height='2'%20rx='1'%20fill='%23555F6A'/%3e%3crect%20x='37'%20y='40'%20width='32'%20height='2'%20rx='1'%20fill='%23555F6A'/%3e%3crect%20y='120'%20width='12'%20height='2'%20rx='1'%20fill='%23555F6A'/%3e%3crect%20x='16'%20y='30'%20width='32'%20height='2'%20rx='1'%20fill='%233A8E51'/%3e%3crect%20x='16'%20y='40'%20width='17'%20height='2'%20rx='1'%20fill='%233A8E51'/%3e%3crect%20x='52'%20y='30'%20width='11'%20height='2'%20rx='1'%20fill='%233A8E51'/%3e%3crect%20x='16'%20y='110'%20width='22'%20height='2'%20rx='1'%20fill='%233A8E51'/%3e%3crect%20y='90'%20width='12'%20height='2'%20rx='1'%20fill='%23555F6A'/%3e%3crect%20y='100'%20width='12'%20height='2'%20rx='1'%20fill='%23555F6A'/%3e%3crect%20x='16'%20y='90'%20width='22'%20height='2'%20rx='1'%20fill='%233A8E51'/%3e%3crect%20x='42'%20y='90'%20width='16'%20height='2'%20rx='1'%20fill='%233A8E51'/%3e%3crect%20x='52'%20y='80'%20width='35'%20height='2'%20rx='1'%20fill='%233A8E51'/%3e%3crect%20x='16'%20y='50'%20width='22'%20height='2'%20rx='1'%20fill='%23873A48'/%3e%3crect%20x='16'%20y='120'%20width='17'%20height='2'%20rx='1'%20fill='%23873A48'/%3e%3crect%20x='16'%20y='80'%20width='32'%20height='2'%20rx='1'%20fill='%233A8E51'/%3e%3crect%20x='16'%20y='100'%20width='17'%20height='2'%20rx='1'%20fill='%233A8E51'/%3e%3c/g%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: 28px 18px;
  background-size: 120px
}

._mockEditor__preview_1cl88_323 {
  position: relative;
  flex: 1;
  height: 100%;
  transition: flex 1.2s ease, height 1.2s ease;
  background-image: url("data:image/svg+xml,%3csvg%20width='200'%20height='128'%20viewBox='0%200%20200%20128'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20opacity='0.2'%3e%3crect%20opacity='0.5'%20x='0.5'%20y='0.5'%20width='199'%20height='16'%20rx='1.5'%20stroke='%23555F6A'/%3e%3crect%20x='10'%20y='8'%20width='12'%20height='1'%20rx='0.5'%20fill='%23555F6A'/%3e%3crect%20opacity='0.5'%20x='0.5'%20y='100.5'%20width='73'%20height='115'%20rx='1.5'%20transform='rotate(-90%200.5%20100.5)'%20stroke='%23555F6A'/%3e%3crect%20x='10'%20y='36'%20width='12'%20height='1'%20rx='0.5'%20fill='%23555F6A'/%3e%3crect%20x='10'%20y='51'%20width='19'%20height='1'%20rx='0.5'%20fill='%23555F6A'/%3e%3crect%20x='17'%20y='59'%20width='17'%20height='1'%20rx='0.5'%20fill='%23555F6A'/%3e%3crect%20x='10'%20y='59'%20width='5'%20height='1'%20rx='0.5'%20fill='%23555F6A'/%3e%3crect%20x='31'%20y='51'%20width='11'%20height='1'%20rx='0.5'%20fill='%23555F6A'/%3e%3crect%20x='36'%20y='59'%20width='14'%20height='1'%20rx='0.5'%20fill='%23555F6A'/%3e%3crect%20opacity='0.5'%20x='0.5'%20y='111.5'%20width='56'%20height='16'%20rx='1.5'%20stroke='%233D9CB1'/%3e%3crect%20x='22'%20y='119'%20width='14'%20height='1'%20rx='0.5'%20fill='%233D9CB1'/%3e%3c/g%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: 52px 48px;
  background-size: 444px;
  overflow: hidden
}

._mockEditor__codeConsole_1cl88_335 {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 22%;
  border-top: solid 1px rgba(255, 255, 255, .1);
  /* background-color: #1a1d22; */
  transition: height 1.2s ease;
  background-image: url("data:image/svg+xml,%3csvg%20width='96'%20height='72'%20viewBox='0%200%2096%2072'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20opacity='0.2'%3e%3crect%20width='21'%20height='2'%20rx='1'%20fill='%23555F6A'/%3e%3crect%20x='79'%20y='52'%20width='24'%20height='2'%20rx='1'%20transform='rotate(-180%2079%2052)'%20fill='%2392A1B2'%20fill-opacity='0.52'/%3e%3crect%20x='51'%20y='52'%20width='14'%20height='2'%20rx='1'%20transform='rotate(-180%2051%2052)'%20fill='%2392A1B2'%20fill-opacity='0.52'/%3e%3crect%20x='33'%20y='52'%20width='33'%20height='2'%20rx='1'%20transform='rotate(-180%2033%2052)'%20fill='%2392A1B2'%20fill-opacity='0.52'/%3e%3crect%20y='20'%20width='12'%20height='2'%20rx='1'%20fill='%23555F6A'/%3e%3crect%20y='40'%20width='21'%20height='2'%20rx='1'%20fill='%233D9CB1'/%3e%3crect%20y='60'%20width='12'%20height='2'%20rx='1'%20fill='%233D9CB1'/%3e%3crect%20y='30'%20width='32'%20height='2'%20rx='1'%20fill='%23555F6A'/%3e%3crect%20y='70'%20width='32'%20height='2'%20rx='1'%20fill='%23555F6A'/%3e%3crect%20x='16'%20y='20'%20width='57'%20height='2'%20rx='1'%20fill='%23555F6A'/%3e%3crect%20x='77'%20y='20'%20width='19'%20height='2'%20rx='1'%20fill='%23555F6A'/%3e%3c/g%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: 28px 18px;
  background-size: 120px
}

.content__title {
  font-size: 8vw;
  margin: 0;
  color: var(--color-title);
  /* text-transform: lowercase; */
  letter-spacing: -0.05em;
  text-indent: -0.05em;
  font-family: 'Montserrat', sans-serif;
  /* font-weight: 900; */
  font-weight: 500;
}
</style>